import { lazy } from "react";
import { Route, Routes } from "react-router-dom";

const ComingSoon = lazy (() => import("../components/ComingSoon"));

export default function RouteIndex() {
    return (
        <Routes>
            <Route path="/" element={<ComingSoon />} />
        </Routes>
    )
}

